import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'
import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Calendar } from 'react-multi-date-picker'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import pepApi from 'services/api/pep'

import styles from './PMSReports.module.scss'

export function PMSReports() {
  const LOGIN_PEP_URL = 'https://login.pep-pv.hilton.com/hk-home/index.html#'
  const PEP_API_BASE_URL = 'https://api.pep-pv.hilton.com'

  const { addToast } = useToasts()

  const filePondRef = React.useRef(null)
  const [filePickerKey, setFilePickerKey] = useState(0)
  const [activity, setActivity] = useState([])
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [apiBaseURL, setApiBaseURL] = useState(PEP_API_BASE_URL)
  const [pepLoginURL, setPepLoginURL] = useState(LOGIN_PEP_URL)

  const sessionId = useSelector(s => s.login.sessionId)

  const getData = React.useCallback(() => {
    pepApi
      .getActivity()
      .then(res => {
        setActivity(convertToDatesArray(res.activities))
        setStartDate(moment(res.startDate))
        setEndDate(moment(res.endDate))
      })
      .catch(() => {
        addToast('Something went wrong', {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }, [addToast])

  function handleClickLoginToPepButton() {
    pepApi.getActivity().then(res => {
      const startDate = res.startDate
      const endDate = res.endDate
      const dates = convertToDatesArray(res.activities)
      const missingDates = getDatesBetween(startDate, endDate).filter(
        date => !dates.includes(date)
      )
      if (window?.electron?.postMessage) {
        window.electron.postMessage({
          type: 'report-status',
          data: {
            status: 'success',
            missingDates,
            startDate,
            endDate,
            pms: 'pep',
            sessionId,
            apiBaseURL,
            pepLoginURL
          }
        })
      }
    })
  }

  useEffect(() => {
    getData()
  }, [getData])

  const missingDates = React.useMemo(
    () => getDatesBetween(startDate, endDate).filter(date => !activity.includes(date)),
    [activity, endDate, startDate]
  )

  const isMissing = false
  if (!isMissing) {
    const callPEPLast3Days = () => {
      let today = moment().format('YYYY-MM-DD')
      let lastDay = moment().subtract(3, 'days').format('YYYY-MM-DD')
      const Acts = pepApi.getActivity(r => r.activities)
      let turnData = []
      for (let act of Acts) {
        if (
          moment(act.startDate).format('yyyy-mm-dd') >= lastDay &&
          moment(act.endDate).format('yyyy-mm-dd') <= today
        ) {
          turnData.push(act)
        }
      }
    }
  }

  function handleUploadComplete(res) {
    setFilePickerKey(old => old + 1)
    getData()

    const data = JSON.parse(res)

    if (data.isSuccess) {
      addToast('File uploaded successfully', {
        appearance: 'success',
        autoDismiss: true
      })
    } else {
      addToast(data.message || 'Something went wrong while uploading file', {
        appearance: 'error',
        autoDismiss: true
      })
    }
  }

  return (
    <div className={styles.container}>
      <CustomHeader width={1180} title="PMS Reports" />
      <div className={styles.left}>
        {missingDates.length > 0 ? (
          <div className={styles.warningCard}>
            {activity.length > 0 ? (
              <>Reports between {convertToPeriodFormat(missingDates)} are missing</>
            ) : (
              <>No report updated</>
            )}
          </div>
        ) : (
          <div className={styles.successCard}>All reports are uploaded</div>
        )}

        <div className={styles.dropZoneWrapper}>
          <p className={styles.title}>Upload Hilton PEP report</p>
          <p className={styles.subTitle}>Upload a HAR file</p>

          <div className={styles.dropZone}>
            <DragAndDropUploader
              key={filePickerKey}
              labelIdle="
              <p class='filepond-p-mini'>drop files here</p>
              <span class='filepond-or'>or</span> <span class='filepond--label-action-mini primary'>Select file</span>"
              url="/pms/upload"
              ref={filePondRef}
              onLoad={handleUploadComplete}
              onError={() => {
                addToast('Something went wrong while uploading file', {
                  appearance: 'error',
                  autoDismiss: true
                })
              }}
            />
          </div>
        </div>
        <TextInput
          label="PEP login url"
          value={pepLoginURL}
          onChange={e => setPepLoginURL(e.target.value)}
        />
        <TextInput
          label="API base URL"
          value={apiBaseURL}
          onChange={e => setApiBaseURL(e.target.value)}
        />
        <PrimaryBigButton
          onClick={handleClickLoginToPepButton}
          disabled={!pepLoginURL || !apiBaseURL}
        >
          Login to PEP
        </PrimaryBigButton>
      </div>
      <div className={styles.right}>
        <Calendar
          className={styles.calendar}
          numberOfMonths={2}
          shadow={false}
          mapDays={({ date }) => {
            const isActivity = activity.includes(date.format('YYYY-MM-DD'))
            const isDisabled =
              moment(date.format('YYYY-MM-DD')).isBefore(startDate) ||
              moment(date.format('YYYY-MM-DD')).isAfter(endDate)

            let props = {}

            props.style = {
              borderRadius: 0,
              background: isDisabled ? 'white' : isActivity ? '#66BB6A' : '#F76060',
              color: isDisabled ? 'var(--grayLighter)' : 'white',
              margin: -4
            }

            return props
          }}
        />
      </div>
    </div>
  )
}

function checkLast3Days(item) {
  const today = moment().format('YYYY-MM-DD')
  const lastDay = moment().subtract(3, 'days').format('YYYY-MM-DD')
}

function getDatesBetween(start, end) {
  const dates = []
  let currentDate = moment(start).startOf('day')
  const endDate = moment(end).startOf('day')

  while (currentDate <= endDate) {
    dates.push(currentDate.format('YYYY-MM-DD'))
    currentDate.add(1, 'days')
  }

  return dates
}

function convertToDatesArray(data) {
  const result = []

  for (const item of data) {
    const dates = getDatesBetween(item.startDate, item.endDate)
    result.push(...dates)
  }

  return result
}

function formatDate(date) {
  return moment(date).format('MMM D YYYY')
}

function formatPeriodDate(start, end) {
  return `${moment(start).format('MMM D')} to ${moment(end).format('MMM D YYYY')}`
}

function convertToPeriodFormat(dates) {
  const sortedDates = dates.sort()
  const formattedDates = []
  let start = moment(sortedDates[0])
  let end = moment(sortedDates[0])

  for (let i = 1; i < sortedDates.length; i++) {
    const currentDate = moment(sortedDates[i])
    const nextDate = moment(sortedDates[i - 1]).add(1, 'day')

    if (currentDate.isSame(nextDate, 'day')) {
      end = currentDate
    } else {
      if (start.isSame(end, 'day')) {
        formattedDates.push(formatDate(start))
      } else {
        formattedDates.push(formatPeriodDate(start, end))
      }
      start = currentDate
      end = currentDate
    }
  }

  if (start.isSame(end, 'day')) {
    formattedDates.push(formatDate(start))
  } else {
    formattedDates.push(`${formatDate(start)} to ${formatDate(end)}`)
  }

  return formattedDates.join(', ')
}
